<itc-toggle-panel iconClass="fa-regular fa-circle-question" [label]="'header.help' | translate">
  <div class="help-toggle-panel__item" (click)="openLink(helpLinks.knowledgeBase.url)">
    {{ helpLinks.knowledgeBase.labelTranslateKey | translate }}
  </div>
  <div class="help-toggle-panel__item" (click)="openLink(helpLinks.status.url)">
    {{ helpLinks.status.labelTranslateKey | translate }}
  </div>
  <div class="help-toggle-panel__item" (click)="openLink(helpLinks.releaseNotes.url)">
    {{ helpLinks.releaseNotes.labelTranslateKey | translate }}
  </div>
  <div class="help-toggle-panel__item" (click)="openLink(helpLinks.kaseyaInnovations.url)">
    {{ helpLinks.kaseyaInnovations.labelTranslateKey | translate }}
  </div>
  @if (hasAccessToMedalliaIntegrationView()) {
    <div class="help-toggle-panel__item" (click)="provideFeedback()">
      {{ 'header.provide-feedback' | translate }}
    </div>
  }
  <div class="help-toggle-panel__divider"></div>
  <div class="help-toggle-panel__item" (click)="openLink(helpLinks.legalTerms.url)">
    {{ helpLinks.legalTerms.labelTranslateKey | translate }}
  </div>
  @if (hasAccessToLegalTermsArchiveView()) {
    <div
      class="help-toggle-panel__item"
      routerLinkActive="help-toggle-panel__item--active"
      [routerLink]="helpLinks.legalTermsArchive.url"
      (click)="closePanel()"
    >
      {{ helpLinks.legalTermsArchive.labelTranslateKey | translate }}
    </div>
  }
</itc-toggle-panel>
